import { gql } from '@apollo/client';

export const GET_SYSTEM_LOGS = gql`
  query systemLogsConnection(
    $first: Int
    $after: Cursor
    $last: Int
    $before: Cursor
    $filter: SystemLogFilter
    $condition: SystemLogCondition
    $orderBy: [SystemLogsOrderBy!]
  ) {
    systemLogsConnection(
      first: $first
      after: $after
      last: $last
      before: $before
      filter: $filter
      condition: $condition
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          type
          timestamp
          level
          details
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
